import { Outlet } from "react-router-dom";

const WasteManagementDashboardLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default WasteManagementDashboardLayout;
